import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Reserves() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const charger = () => api.get("/prospection/reserves").then((r) => setD(r.data));
  useEffect(() => { charger(); }, []);
  const importer = () => api.post("/prospection/import-automatique", { nombre: 500 }).then((r) => { toast.success(`Import simulé : ${r.data.importes} contacts.`); charger(); }).catch((e) => toast.error(messageErreur(e)));
  const operation = () => api.post("/prospection/nouvelle-operation").then((r) => toast.success(`${r.data.remis_en_reserve} contact(s) remis en réserve.`)).catch((e) => toast.error(messageErreur(e)));
  if (!d) return null;
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="text-base md:text-lg font-bold">Réserves par région</h2>
        <p className="text-sm at-muted" data-testid="reserves-total">{d.total} en stock · {d.frais} frais</p>
      </div>
      {user.role === "dirigeant" && (
        <div className="flex flex-col sm:flex-row gap-2">
          <button type="button" className="at-btn at-btn-ghost flex-1" onClick={importer} data-testid="reserves-import-auto">Lancer l'import automatique (simulation)</button>
          <button type="button" className="at-btn at-btn-ghost flex-1" onClick={operation} data-testid="reserves-new-operation">Nouvelle opération lancée</button>
        </div>
      )}
      <div className="grid sm:grid-cols-2 gap-2" data-testid="reserves-list">
        {d.regions.map((r) => (
          <div key={r.region} className="at-card p-4" data-testid={`reserve-${r.region}`}>
            <div className="flex items-start justify-between gap-2">
              <p className="font-bold">{r.region}</p>
              {r.alerte && <span className="text-xs font-bold flex items-center gap-1 shrink-0" style={{ color: "var(--danger)" }} data-testid={`reserve-alert-${r.region}`}><AlertTriangle size={13} />Rien de neuf depuis 7 j</span>}
            </div>
            <div className="grid grid-cols-4 gap-2 mt-2 text-center">
              {[["Stock", r.stock], ["Frais", r.frais], ["Jours", r.jours_restants ?? "—"], ["Recyclage", r.recyclage]].map(([l, v]) => (
                <div key={l} className="at-soft p-2"><p className="text-[11px] at-muted">{l}</p><p className="font-bold">{v}</p></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
